import { useState } from 'react';
import moment from 'moment'
import Slider from 'react-slick';
import ImageWithFallback from '../ImageWithFallback';
import JobSavedToggle from '@/Component/Influencer/InfluencerJobs/JobSavedToggle';
import { WhiteFacebookSVG, WhiteInstagramSVG, WhiteTiktokSVG, WhiteXiaohongshuSVG } from '../SVGs/CommonSVG';
import { WhiteYoutubeSVG, YoutubeSVG } from '../SVGs/AuthSVG';
import { formatNumberWithCommas } from '@/Utils/Other/FormatNumberWithCommas';
import { translateJobRequirements } from '@/Utils/Other/TranslateJobRequirement';
import { getAttachmentKey, parseCampaignAttachment } from '@/Utils/Other/campaignAttachment';
import CampaignBannerSlide from './CampaignBannerSlide';

const JobsBox = (props) => {
    const { data, userDetails, setOpenSideModal, translations, activeTab, isFromCreate = false, onCoverClick, isFromAdmin = false, onBannerPositionChange } = props;
    const [isSaved, setIsSaved] = useState(data?.isCampaignSaved);

    const handleBoxClick = (event) => {
        // if (isFromCreate) return;
        if (event.target.tagName === 'BUTTON' || event.target.tagName === 'A' || event.target.closest('button') || event.target.closest('a')) {
            return;
        }
        setOpenSideModal({ slug: data?.slug, campaignDetailId: data?.id});
    };

    const sliderSettings = {
        dots: true,
        arrows: false,
        centerMode: false,
        infinite: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: !isFromCreate,
        autoplaySpeed: 3000,
        swipeToSlide: !isFromCreate,
        swipe: !isFromCreate,
        draggable: !isFromCreate,
        touchMove: !isFromCreate,
        fade: false,
        pauseOnHover: !isFromCreate,
    };

    const availableIcons = {
        facebook: <WhiteFacebookSVG customClass='min-w-4 w-4 min-h-4 h-4' />,
        instagram: <WhiteInstagramSVG customClass='min-w-4 w-4 min-h-4 h-4' />,
        youtube: <WhiteYoutubeSVG customClass='min-w-8 w-8 min-h-8 h-8' />,
        tiktok: <WhiteTiktokSVG customClass='min-w-4 w-4 min-h-4 h-4' />,
        xiaohongshu: <WhiteXiaohongshuSVG customClass='min-w-4 w-4 min-h-4 h-4' />
    };

    const getApplicantRangeLabel = (applied) => {
        const count = applied ?? 0;
        if (count === 0) return 'Be the first to apply';
        if (count < 10) return '< 10';
        if (count < 25) return '10 - 25';
        if (count < 50) return '25 - 50';
        if (count < 100) return '50 - 100';
        return '100+';
    };


    const attachmentKey = getAttachmentKey(data?.attachment);

    return (
        <div className={`min-w-0 ${isFromCreate ? 'max-w-[500px] mx-auto' : 'max-w-full'} border border-neutral-100 rounded-card overflow-hidden bg-white shadow-soft hover:shadow-float hover:-translate-y-0.5 transition-all duration-200 h-full`}>
            <div className='relative min-w-0 w-full cursor-pointer overflow-hidden' onClick={handleBoxClick}>
                {data?.campaignInfluencers?.[0]?.is_applied && activeTab !== 'applied' && <div className='absolute top-2 right-2 bg-primary text-white  text-xs font-semibold px-3 py-1 rounded-full z-10'>{translations?.applied}</div>}
                {data?.attachment?.length > 0 ?
                    <div className="min-w-0 w-full">
                        <Slider {...sliderSettings} key={attachmentKey} className={`campaign-slider ${isFromCreate ? 'campaign-slider--create' : ''}`}>
                            {data?.attachment?.map((item, index) => (
                                <CampaignBannerSlide
                                    key={parseCampaignAttachment(item).fileName || index}
                                    item={item}
                                    userDetails={userDetails}
                                    isFromCreate={isFromCreate}
                                    onCoverClick={onCoverClick}
                                    onBannerPositionChange={onBannerPositionChange}
                                />
                            ))}
                        </Slider>
                    </div>
                    :
                    <div className='h-40 w-full bg-gray/25 focus-visible:outline-none focus:outline-none focus-visible:border-none focus:border-none' onClick={() => isFromCreate && onCoverClick?.()} >
                        <ImageWithFallback src={'/assets/images/placeholder-banner.png'} alt="Campaign Banner" width={500} height={500} className='w-full h-full object-cover' />
                    </div>
                }
                <div className={`absolute top-0 bottom-0 left-0 flex flex-col items-center justify-center gap-3 px-2 bg-black/50 ${isFromCreate ? 'pointer-events-none' : ''}`}>
                    {data?.platforms?.map(platform => availableIcons[platform])}
                </div>
            </div>
            <div className='p-4 pt-0 cursor-pointer hover:bg-primary/5 relative' onClick={handleBoxClick}>
                <div className='flex items-end justify-between'>
                    <div className='min-w-14 w-14 h-14 rounded-full overflow-hidden border border-lightGray bg-gray -mt-6'>
                        <ImageWithFallback src={data?.users?.image} alt="Logo" width={50} height={50} className='w-full h-full object-contain' />
                    </div>
                    {data?.isArchived == 1 && <div className='rounded-full overflow-hidden text-white bg-gradient-to-br from-secondary to-primary py-0.5 px-3 font-medium absolute -top-3 text-sm left-3.5'>Archived</div>}
                    {data?.campaignInfluencers?.[0]?.is_terminate_job_request ?
                        <span className="font-medium text-xs text-red-500">{translations?.terminatedByBrand}</span>
                        : ((data?.campaignInfluencers?.[0]?.job_status == 'closed') || (data?.campaignInfluencers?.[0]?.job_status == 'cancelled')) ?
                            <span className={`font-medium text-xs ${data?.campaignInfluencers?.[0]?.job_status == 'closed' ? 'text-green-500' : 'text-red-500'}`}>{data?.campaignInfluencers?.[0]?.job_status == 'closed' ? translations?.completed : translations?.cancelled} on {moment(data?.campaignInfluencers?.[0]?.updatedAt).format('DD MMM YYYY')}</span> :
                            <span className='font-medium text-xs'>{moment(data?.posting_start_date).format('DD MMM YYYY')} - {moment(data?.posting_end_date).format('DD MMM YYYY')}</span>
                    }
                </div>
                <div className='flex flex-col gap-0.5 mt-4'>
                    <h4 className='text-base font-bold inline items-center flex-wrap'>
                        <span className='me-2'>{data?.campaign_name}</span>
                        <span className={`rounded-full overflow-hidden py-0.5 px-3 font-medium text-xs capitalize border ${data?.job_privacy == 'in_person' ? 'bg-purple-50 text-purple-700 border-purple-200' : 'bg-pink-50 text-pink-700 border-pink-200'}`}>{data?.job_privacy == 'in_person' ? translations?.inPerson : translations?.remote}</span></h4>
                    <span className='font-medium text-sm'>{data?.users?.company_name}</span>
                    <div className='inline-block items-center text-xs'>
                        <span className='text-xs'>{data?.campaign_country}</span>
                        {data?.job_requirement?.length > 0 && <span className="rounded-full overflow-hidden text-gray min-w-1 h-1 bg-gray mx-1.5 inline-block align-middle"></span>}
                        <span>{translateJobRequirements(data?.job_requirement, translations)}</span>
                    </div>
                    <div className='flex items-center justify-between md:gap-5 gap-3 mt-5'>
                        <div className='flex items-center md:gap-7 gap-5'>
                            {data?.budget_per_influencer > 0 && <div className='flex flex-col'>
                                <span className='font-semibold text-sm whitespace-nowrap'>${formatNumberWithCommas(data?.budget_per_influencer)} {data?.currency}</span>
                                <span className='text-xs whitespace-nowrap'><span role="img" aria-label="cash" className="mr-1">💰</span>{translations?.cash}</span>
                            </div>}
                            {data?.product_value > 0 && <div className='flex flex-col'>
                                <span className='font-semibold text-sm whitespace-nowrap'>${formatNumberWithCommas(data?.product_value)} {data?.currency}</span>
                                <span className='text-xs whitespace-nowrap'><span role="img" aria-label="cash" className="mr-1">🎁</span>{translations?.productValue}</span>
                            </div>}
                            <div className='flex flex-col'>
                                <span className='font-semibold text-sm'>{getApplicantRangeLabel(data?.applied)}</span>
                                {(data?.applied ?? 0) !== 0 && (
                                    <span className='text-xs '>{translations?.applicants}</span>
                                )}
                            </div>
                        </div>
                        {!isFromCreate && !isFromAdmin && <JobSavedToggle data={data} setIsSaved={setIsSaved} isSaved={isSaved} />}
                    </div>
                    {/* <div className='flex items-center justify-between md:gap-5 gap-3 mt-5'>
                        <div className="flex gap-5 justify-start">
                            {data?.platforms?.map(platform => availableIcons[platform])}
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    )
}

export default JobsBox
